import API_ROUTES from '../../../api'
import httpClient from '../../../shared/api/httpClient'

export const matchApi = {
    getList(params) {
        return httpClient.get(API_ROUTES.game_list, { params })
    },

    getDetail(gameId) {
        return httpClient.get(API_ROUTES.game_info, {
            params: { id: gameId },
        })
    },
}
